var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.374.287a1.5 1.5 0 0 0-2.093.345L7.246 20.2l-4.685-4.689a1.5 1.5 0 0 0-2.122 2.121l5.935 5.934a1.525 1.525 0 0 0 2.279-.186l15.066-21a1.5 1.5 0 0 0-.345-2.093z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export { SvgCheck1 as ReactComponent };
export default __webpack_public_path__ + "f1ac7badea046a11d14c1dbe673338ad3759ff084377a44a426264916727ce85.svg";